module.exports = __webpack_public_path__ + "img/holdbill.6d821f37.svg";